import { render, staticRenderFns } from "./SearchTabInternalChat.vue?vue&type=template&id=6ab64270&scoped=true&"
import script from "./SearchTabInternalChat.vue?vue&type=script&lang=js&"
export * from "./SearchTabInternalChat.vue?vue&type=script&lang=js&"
import style0 from "./SearchTabInternalChat.vue?vue&type=style&index=0&id=6ab64270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab64270",
  null
  
)

export default component.exports